import type { Session } from '@supabase/supabase-js';
import { supabaseClient } from './api/supabase';

export type User = {
  id: string;
  email: string;
};

export const auth = {
  getSession: async () => {
    return supabaseClient.auth.getSession();
  },

  signIn: async (email: string, password: string) => {
    return supabaseClient.auth.signInWithPassword({ email, password });
  },

  signUp: async (email: string, password: string) => {
    return supabaseClient.auth.signUp({ email, password });
  },

  signOut: async () => {
    return supabaseClient.auth.signOut({ scope: 'local' });
  },

  resetPassword: async (email: string, redirectTo: string) => {
    return supabaseClient.auth.resetPasswordForEmail(email, { redirectTo });
  },

  updatePassword: async (newPassword: string) => {
    return supabaseClient.auth.updateUser({ password: newPassword });
  },

  onAuthStateChange: (
    callback: (event: string, session: Session | null) => void,
  ) => {
    return supabaseClient.auth.onAuthStateChange(callback);
  },
};

export type Auth = typeof auth;
